import React from "react";
import { Link } from "react-router-dom";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
// import { ArrowLeft } from "lucide-react";

const NotFoundPage = () => {
      return (
            <>
                  <Header />
                  <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-center px-6">
                        <h1 className="text-6xl font-bold text-gray-800">404</h1>
                        <h2 className="text-2xl font-semibold text-gray-600 mt-2">Page Not Found</h2>
                        <p className="text-gray-500 mt-4">The page you are looking for doesn’t exist or has been moved.</p>
                        <Link
                              to="/"
                              className="mt-6 flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-blue-700 transition-all"
                        >
                              {/* <ArrowLeft className="w-5 h-5" /> */}
                              Go Back Home
                        </Link>
                  </div>
                  <Footer />
            </>
      );
};

export default NotFoundPage;
